type ImpersonationMeta = {
  isOrganiser?: boolean;
};

type ImpersonationEntry = {
  token: string;
  meta?: ImpersonationMeta;
};

let _entry: ImpersonationEntry | null = null;

export const impersonationStore = {
  set: (token: string, meta?: ImpersonationMeta) => {
    _entry = { token, meta };
  },
  get: () => _entry,
  clear: () => {
    _entry = null;
  },
};
